import React, { Fragment, useState } from "react";
import moment from "moment";
import ShippingInformation from "./ShippingInformation";
import { MainBlock } from "../../../../../common/Buttons";
import { returnEuroString } from "../../../../../../helpers/Utils";
import { GoPrimitiveDot } from "react-icons/go";
import { FiAlertCircle } from "react-icons/fi";
import { FaTrash } from "react-icons/fa";
import { Tooltip } from "antd";
import { Modal } from "antd";
import { useMemo } from "react";
import ShipmentEmailPreview from "./ShipmentEmailPreview";
import { useDispatch } from "react-redux";
import { removeShipmentBeforeCalled } from "../../../../../../redux/Actions/shipmentsAction";

function ShippmentTable({ item, record_id, mode, orderId, onNewLabel }) {
  // console.log('ShipmentTable: ', record_id);
  const dispatch = useDispatch();
  const [MoreInformation, setMoreInformation] = useState(false);
  const relatedOrderNumbers = Array.isArray(item.related_order_numbers)
    ? item.related_order_numbers.filter(Boolean)
    : [];
  const groupedBadgeTooltip =
    relatedOrderNumbers.length > 0
      ? relatedOrderNumbers.join("\n")
      : "No related orders";
  const isCombinedShipment =
    item?.manifest?.to_office === true && !!item?.manifest?.store;
  const canDeleteShipment = item?.can_be_deleted && item?.deleted_at == null;
  const canCreateNewLabel =
    typeof onNewLabel === "function" &&
    !item.deleted_at &&
    !item.picked_up_at &&
    !item.delivered_at &&
    (item.shipment_order_rows || []).some((e) => !e.canceled_at && !e.deleted_at);
  const showDeleteButton = canDeleteShipment && (!item.courier_trackings || item.courier_trackings.length === 0);


  const handleDeleteShipment = () => {
    if (item.picked_up_at || item.delivered_at) {
      const trackingNumber = item.courier_trackings?.[0]?.number;
      Modal.error({
        title: "Shipment is already in progress and cannot be deleted",
        width: 480,
        content: `Shipment has already been ${item.delivered_at ? "delivered" : "picked up"
          }${trackingNumber ? ` (tracking nr. ${trackingNumber})` : ""}. Cannot be deleted.`,
      });
      return;
    }
    if (confirm("Are you sure you want to delete this shipment?")) {
      const orderId = item.service_order_id || item.order?.id;
      const order_type = item.service_order_type || "Order";
      dispatch(removeShipmentBeforeCalled(item.id, orderId, order_type));
    }
  };

  const courier_tracking = useMemo(() => {
    return (
      <>
        {item.courier_trackings &&
          item.courier_trackings.map((courier) => (
            <div
              key={courier.number}
              className="d-flex flex-column mt-1 bg-light-primary"
              style={{
                padding: "8px 8px 5px",
                borderRadius: 2,
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <p
                    className="mb-0 mr-1"
                    style={{
                      color: "#014894",
                      fontWeight: 400,
                      fontSize: 10,
                      lineHeight: 1,
                    }}
                  >
                    Tracking number
                  </p>
                  {(item.picked_up_at || item.delivered_at) && (
                    <span
                      className="text-xss text-white d-inline-block"
                      style={{
                        backgroundColor: item.delivered_at ? "#28a745" : "#17a2b8",
                        fontSize: 9,
                        borderRadius: 12,
                        padding: "2px 8px",
                        lineHeight: 1.5,
                      }}
                    >
                      {item.delivered_at ? "Delivered" : "Picked up"}
                    </span>
                  )}
                </div>
                {canDeleteShipment && (
                  <Tooltip placement="top" title="Delete shipment">
                    <FaTrash
                      className="text-danger cursor-pointer"
                      style={{ fontSize: 12 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteShipment();
                      }}
                    />
                  </Tooltip>
                )}
              </div>
              <div className="d-flex align-items-center mt-1">
                <ShipmentEmailPreview
                  shipment_emails={item?.shipment_emails || []}
                  tracking_number={courier.number}
                />
                <a
                  className="text-black mb-0 text-xs font-normal"
                  style={{ pointerEvents: "all" }}
                  href={courier.url}
                  target="_blank"
                >
                  <u>{courier.number}</u>
                </a>
              </div>
            </div>
          ))}
        {(item.external_order_number || isCombinedShipment) && (
          <div
            className="d-flex flex-column mt-1 bg-light-primary"
            style={{
              padding: "8px 8px 5px",
              borderRadius: 2,
            }}
          >
            <div className="d-flex align-items-start flex-wrap" style={{ columnGap: 8, rowGap: 4 }}>
              {item.external_order_number && (
                <div className="d-flex flex-column mr-2">
                  <p
                    className="mb-0"
                    style={{
                      color: "#014894",
                      fontWeight: 400,
                      fontSize: 10,
                      lineHeight: 1,
                    }}
                  >
                    EN:
                  </p>
                  <p className="text-black mb-0 text-xs mt-1">
                    {item.external_order_number}
                  </p>
                </div>
              )}
              {isCombinedShipment && (
                <Tooltip placement="top" title={"Orders: " + groupedBadgeTooltip}>
                  <span
                    className="text-xss text-white d-inline-block"
                    style={{
                      backgroundColor: "#8678ab",
                      fontSize: 9,
                      borderRadius: 12,
                      padding: "2px 8px",
                      lineHeight: 1.5,
                    }}
                  >
                    Combined
                  </span>
                </Tooltip>
              )}
            </div>
          </div>
        )}
      </>
    );
  }, [
    item.external_order_number,
    item.courier_trackings,
    item.manifest,
  ]);
  return (
    <>
      {item.api_errors !== null && (
        <tr className="table-danger">
          <td className="px-4" colSpan="3">
            {item.api_errors}
          </td>
        </tr>
      )}
      <tr>
        <td className="p-0">
          <MainBlock
            className="pb-3"
            color={"#a8e2df"}
            height="auto"
            action={MoreInformation}
            onChange={() => setMoreInformation((prevState) => !prevState)}
          >
            <div>
              {item.shipment_additional_services.some(
                (some) =>
                  some.service_key == "order_return" && some.service_value == 1
              ) && (
                  <span className="badge badge-pill badge-danger">
                    Pickup from the customer
                  </span>
                )}
            </div>
            <div
              className="d-flex justify-content-between align-items-center px-2"
              style={{ fontSize: "13px", fontWeight: 400 }}
            >
              <p className="mb-0">
                {!item.printed_at &&
                  ["dpd", "lp_express", "omniva", "venipak"].includes(
                    item.shipment_type
                  ) && (
                    <Tooltip placement="top" title={"Not printed"}>
                      <FiAlertCircle className="text-danger cursor-pointer" />{" "}
                    </Tooltip>
                  )}
                {item.pickup_address.company +
                  " - " +
                  item.pickup_address.address +
                  " - " +
                  item.pickup_address.city}
              </p>
              {item.user_title && (
                <p className="mb-0 px-2">{item.user_title}</p>
              )}
              <div>
                <p className="mb-0">
                  {moment(item.created_at).format("YYYY-MM-DD")}
                </p>
                <p className="mb-0">
                  {moment(item.created_at).format("HH:mm")}
                </p>
              </div>
            </div>
            <div
              className="d-flex justify-content-between align-items-center px-2"
              style={{ fontSize: "13px", fontWeight: 400 }}
            >
              <div>
                {mode === "Servisas" ? (
                  item.shipment_order_rows.length > 0 && (
                    <>
                      {item.shipment_order_rows
                        .filter((e) => !!e.title)
                        .map((order_item, index) => (
                          <div key={index}>
                            <GoPrimitiveDot className="mr-1" color="#a8e2df" />
                            <span className="border-bottom border-danger">
                              {order_item.quantity}x {order_item.title} -{" "}
                              {order_item.price} &#8364;{" "}
                            </span>
                          </div>
                        ))}
                      <div>
                        Total:{" "}
                        <span className="font-weight-bold">
                          {returnEuroString(
                            item.shipment_order_rows
                              .filter((e) => !!e.title)
                              .reduce(
                                (cur, acc) => +acc.price * acc.quantity + cur,
                                0
                              )
                          )}
                        </span>
                      </div>
                    </>
                  )
                ) : (
                  <>
                    {item.shipment_order_rows.map((e) => (
                      <div
                        className={`d-flex align-items-center ${typeof record_id == "number" &&
                          typeof e?.order_row?.order_id == "number" &&
                          record_id !== e?.order_row?.order_id
                          ? "text-danger"
                          : ""
                          } `}
                        key={e.id}
                      >
                        <GoPrimitiveDot className="mr-1" color="#a8e2df" />{" "}
                        {e.deleted_at || e.canceled_at ? (
                          <del>
                            <p className="mb-0">
                              <span className="font-weight-bold pr-1">
                                {e?.quantity ||
                                  Math.floor(e.order_row?.quantity)}
                                *
                              </span>
                              {e.order_row?.product_name || e.order_row_id}
                            </p>
                          </del>
                        ) : (
                          <Fragment>
                            <p className="mb-0">
                              <span className="font-weight-bold pr-1">
                                {e?.quantity ||
                                  Math.floor(e.order_row?.quantity)}
                                *
                              </span>

                              {e.order_row?.product_name || e.order_row_id}
                            </p>
                          </Fragment>
                        )}
                      </div>
                    ))}
                    <p className="mb-0">
                      Total:{" "}
                      <span className="font-weight-bold">
                        {returnEuroString(
                          item.shipment_order_rows.reduce(
                            (cur, acc) =>
                              (+acc.order_row?.unit_price_tax_incl || 0) *
                              (acc.quantity ||
                                Math.floor(acc.order_row?.quantity)) +
                              cur,
                            0
                          )
                        )}
                      </span>
                    </p>
                  </>
                )}
              </div>
            </div>
            <div
              className="d-flex justify-content-between px-2"
              style={{ fontSize: "13px" }}
            >
              {item.picked_up_at && (
                <p className="mb-0">
                  Pickup Date:
                  <br /> {moment(item.picked_up_at).format("YYYY-MM-DD HH:mm")}
                </p>
              )}
              {item.delivered_at && (
                <p className="mb-0">
                  Delivery Date:
                  <br /> {moment(item.delivered_at).format("YYYY-MM-DD HH:mm")}
                </p>
              )}
            </div>
            {item.also_transmission_at &&
              (!item.courier_trackings ||
                item.courier_trackings.length === 0) && (
                <div
                  className="d-flex flex-column mt-1"
                  style={{
                    padding: "8px 8px 5px",
                    borderRadius: 2,
                    backgroundColor: "#fff3cd",
                  }}
                >
                  <p
                    className="mb-0"
                    style={{
                      color: "#014894",
                      fontWeight: 400,
                      fontSize: 10,
                      lineHeight: 1,
                    }}
                  >
                    Užsakymas bus transliuojamas
                  </p>
                  <p className="text-black mb-0 text-xs">
                    {moment(item.also_transmission_at).format(
                      "YYYY-MM-DD HH:mm"
                    )}
                  </p>
                </div>
              )}
            <div>{courier_tracking}</div>
            {(showDeleteButton || canCreateNewLabel) && (
              <div className="d-flex justify-content-end align-items-center px-2 mt-2">
                {canCreateNewLabel && (
                  <Tooltip placement="top" title="Create new label with products from this shipment">
                    <button
                      className="btn btn-sm btn-primary mr-1"
                      style={{ padding: "4px 8px", fontSize: 12 }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onNewLabel(item);
                      }}
                    >
                      New label
                    </button>
                  </Tooltip>
                )}
                {showDeleteButton && <Tooltip placement="top" title="Delete shipment">
                  <button
                    className="btn btn-sm btn-danger"
                    style={{ padding: '4px 8px' }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteShipment();
                    }}
                  >
                    <FaTrash className="text-white" style={{ fontSize: 12 }} />
                  </button>
                </Tooltip>}
              </div>
            )}
          </MainBlock>
        </td>
      </tr>
      {MoreInformation && (
        <ShippingInformation
          mode={mode}
          key={item.id}
          information={item}
          orderId={orderId || item.service_order_id || item.order?.id}
        />
      )}
    </>
  );
}

export default ShippmentTable;
